import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import times from 'lodash/times';

import styles from './Spinner.module.scss';
import { useSparkConfig } from '../SparkConfigProvider';

const spinnerBlades = 12;

/**
 * Spinner creates a spinning animation using SVG and CSS. Best suited to indicate loading state, when the UI is waiting for some external thing to happen before proceeding.
 */
export default function Spinner(props) {
  const { className, centered, ...otherProps } = props;
  const { Spinner: CustomSpinner } = useSparkConfig();

  return (
    <div
      className={classnames(
        styles.spinner,
        { [styles.centered]: centered },
        className,
      )}
      data-testid="spinner"
      {...otherProps}
    >
      {CustomSpinner ? (
        <CustomSpinner />
      ) : (
        <svg viewBox="0 0 100 100">
          {times(spinnerBlades, i => (
            <rect
              key={i}
              x="46.5"
              y="40"
              width="7"
              height="20"
              rx="5"
              ry="5"
              transform={`rotate(-${
                i * (360 / spinnerBlades)
              } 50 50) translate(0  -30)`}
            />
          ))}
        </svg>
      )}
    </div>
  );
}

Spinner.propTypes = {
  className: PropTypes.string,
  centered: PropTypes.bool,
};

Spinner.defaultProps = {
  className: '',
  centered: false,
};

Spinner.displayName = 'Spinner';
